import styled from "styled-components";
import Container from "react-bootstrap/Container";
import trama from "../../assets/Trama-LatamChequea-white.jpg"
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";

export const SyledRowContainer = styled(Row)`
  background: #354052;

  .title {
    font-weight: bold;
    font-size: 28px;
    line-height: 34px;
    color: #ffffff;
    @media (max-width: 991px) {
      text-align: center;
    }
  }
  .text {
    font-weight: normal;
    font-size: 11px;
    line-height: 15px;
    text-align: justify;
    color: #ffffff;
    @media (max-width: 991px) {
      text-align: center;
    }
  }
  .golink {
    background: #e63457;
    border: 1px solid #e63457;
    padding: 11px;
    margin-top: 20px;
    svg {
      color: #fff;
    }
  }
`;


export const SyledForm = styled(Form)`
  @media (max-width: 991px) {
    justify-content: center;
    margin-top: 35px;
  }
  .form-style {
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: end;
    @media (max-width: 600px) {
      align-items: center;
    }
    .form-label {
      color: #fff;
      margin-right: 20px;
      font-size: 12px;
      line-height: 15px;
      font-weight: bold;
    }
    .link {
      display: flex;
      justify-content: end;
      @media (max-width: 600px) {
        display: block;
      }
    }
    button {
      background: #f72d54;
      border-radius: 50px;
      color: white;
      font-weight: bold;
      border: 1px solid #f72d54;
      padding: 5px 25px;
      font-size: 12px;
      line-height: 15px;
    }
  }
`;

